import {Box, Button, Chip, Divider, Paper, TextField, Typography} from "@mui/material";
import {getCompanyCustomers, saveCompanyCustomers} from "../../../services/CompanyService";
import {useMessageContext} from "../../../contexts/MessageContext";
import {useEffect, useState} from "react";
import {Autocomplete} from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';

const CompanyCustomerTab = ({company, setLoader}) => {

  const {notificationHandler} = useMessageContext();

  const [companyCustomers, setCompanyCustomers] = useState();

  const [reload, setReload] = useState(false);

  useEffect(() => {
    setLoader(true);
    getCompanyCustomers(company.id)
        .then(res => {
          setCompanyCustomers(res.data);
        }).then(() => setLoader(false))
  }, [reload, company.id, setLoader]);

  const updateCurrentCustomers = (currentCustomers) => {
    setCompanyCustomers(prv => {
      return {...prv, currentCustomers}
    })
  }

  const updatePotentialCustomers = (potentialCustomers) => {
    setCompanyCustomers(prv => {
      return {...prv, potentialCustomers}
    })
  }

  const updateCompetitors = (competitors) => {
    setCompanyCustomers(prv => {
      return {...prv, competitors}
    })
  }

  return (
    <Paper
      component="form"
      onSubmit={(event => {
        event.preventDefault();
        setLoader(true);
        companyCustomers.companyId = company.id;
        saveCompanyCustomers(companyCustomers)
            .then(() => setReload(prv => !prv))
            .then(() => notificationHandler.success('Company Saved'))
            .finally(() => setLoader(false))
      })}
      sx={{ mt: 3, p: 3 }}
      elevation={1}
    >
      {companyCustomers && (
        <Box>
          {/* Customers Section */}
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2, fontWeight: 600, fontSize: "0.75rem", textTransform: "uppercase" }}>
            Customers
          </Typography>

          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <Autocomplete
                multiple
                size="small"
                id="current-customers"
                sx={{ flex: 1 }}
                options={[]}
                freeSolo
                value={companyCustomers.currentCustomers || []}
                onChange={(event, newValue) => {
                  updateCurrentCustomers(newValue);
                }}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => {
                        const { key, ...tagProps } = getTagProps({ index });
                        return <Chip key={key} size="small" variant="filled" label={option} {...tagProps} />;
                    })
                }
                renderInput={(params) => (
                    <TextField {...params} variant="outlined" label="Current Customers" placeholder="Add customer..." />
                )}
            />
            <Autocomplete
                multiple
                size="small"
                id="potential-customers"
                sx={{ flex: 1 }}
                options={[]}
                freeSolo
                value={companyCustomers.potentialCustomers || []}
                onChange={(event, newValue) => {
                  updatePotentialCustomers(newValue);
                }}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => {
                        const { key, ...tagProps } = getTagProps({ index });
                        return <Chip key={key} size="small" variant="filled" label={option} {...tagProps} />;
                    })
                }
                renderInput={(params) => (
                    <TextField {...params} variant="outlined" label="Potential Customers" placeholder="Add potential customer..." />
                )}
            />
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Competitors Section */}
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2, fontWeight: 600, fontSize: "0.75rem", textTransform: "uppercase" }}>
            Competitors
          </Typography>

          <Autocomplete
              multiple
              size="small"
              id="competitors"
              options={[]}
              freeSolo
              value={companyCustomers.competitors || []}
              onChange={(event, newValue) => {
                updateCompetitors(newValue);
              }}
              renderTags={(value, getTagProps) =>
                  value.map((option, index) => {
                      const { key, ...tagProps } = getTagProps({ index });
                      return <Chip key={key} size="small" variant="filled" label={option} {...tagProps} />;
                  })
              }
              renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="Competitors" placeholder="Add competitor..." />
              )}
          />

          <Divider sx={{ my: 3 }} />

          {/* Actions */}
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="submit"
              variant="contained"
              startIcon={<SaveIcon />}
            >
              Save Changes
            </Button>
          </Box>
        </Box>
      )}
    </Paper>
  );
};

export default CompanyCustomerTab;
